import React from 'react';
import { Link } from 'react-router-dom';

const Footer2 = () => (
  <footer className="page-footer page-footer_navs">
    <div className="container">
      <div className="row">
        <div className="col-xs-24 col-sm-6">
          <nav>
            <ul className="list-unstyled">
              <li>
                <strong>Container 1</strong>
              </li>
              <li>
                <a href="">Container item 1</a>
              </li>
              <li>
                <a href="">Container item 2</a>
              </li>
              <li>
                <a href="">Container item 3</a>
              </li>
              <li>
                <a href="">Container item 4</a>
              </li>
              <li>
                <a href="">Container item 5</a>
              </li>
              <li>
                <a href="">Container item 6</a>
              </li>
            </ul>
          </nav>
        </div>
        <div className="col-xs-24 col-sm-6">
          <nav>
            <ul className="list-unstyled">
              <li>
                <strong>Container 2</strong>
              </li>
              <li>
                <a href="">Container item 1</a>
              </li>
              <li>
                <a href="">Container item 2</a>
              </li>
              <li>
                <a href="">Container item 3</a>
              </li>
              <li>
                <a href="">Container item 4</a>
              </li>
              <li>
                <a href="">Container item 5</a>
              </li>
              <li>
                <a href="">Container item 6</a>
              </li>
            </ul>
          </nav>
        </div>
        <div className="col-xs-24 col-sm-6">
          <nav>
            <ul className="list-unstyled">
              <li>
                <strong>Container 3</strong>
              </li>
            </ul>
          </nav>
        </div>
        <div className="col-xs-24 col-sm-6">
          <nav>
            <ul className="list-unstyled">
              <li>
                <strong>Container 4</strong>
              </li>
              <li>
                <Link to={`/info/polzovatelskoe_soglashenie`}>
                  Пользовательское соглашение
                </Link>
              </li>
              <li>
                <Link to={`/info/soglasie_na_obrabotku_personalnih_dannih`}>
                  Согласие на обработку персональных данных
                </Link>
              </li>
              <li>
                <Link to={`/info/politika_konfidencialnosti`}>
                  Политика конфиденциальности
                </Link>
              </li>
            </ul>
          </nav>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-24 col-sm-6">
          <nav>
            <ul className="list-unstyled">
              <li>
                <strong>Container 5</strong>
              </li>
              <li>
                <a href="">Container item 1</a>
              </li>
              <li>
                <a href="">Container item 2</a>
              </li>
            </ul>
          </nav>
        </div>
        <div className="col-xs-24 col-sm-6">
          <nav>
            <ul className="list-unstyled">
              <li>
                <strong>Container 6</strong>
              </li>
            </ul>
          </nav>
        </div>
        <div className="col-xs-24 col-sm-6">
          <nav>
            <ul className="list-unstyled">
              <li>
                <strong>Container 7</strong>
              </li>
              <li>
                <a href="">Container item 1</a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-24 col-sm-24 page-footer-copyright text-center">
          © {new Date().getFullYear()} TaskPay, Inc.
        </div>
      </div>
    </div>
  </footer>
);

export default Footer2;



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutLandingPage/Footer/Footer2/Footer2.js